export default async ({ store, redirect }) => {
  if (!store.state.auth.isAuthenticatedAdmin) {
    return redirect('/admin/login');
  }
};
